import Main from '@/components/main';
import PreSaleWarehouseForwardEntry from './preSale-warehouse-forward-entry';

export default {
    path: '/pre-sale',
    name: 'pre-sale',
    meta: {
        icon: 'ios-flag',
        title: '预售',
        showAlways: true
    },
    component: Main,
    children: [
        ...PreSaleWarehouseForwardEntry
    ]
};
